export let FeedbackFilterType;

(function (FeedbackFilterType) {
  FeedbackFilterType["All"] = "all";
  FeedbackFilterType["Members"] = "user";
  FeedbackFilterType["Auto"] = "system";
})(FeedbackFilterType || (FeedbackFilterType = {}));